// action types
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";

// action creators
export const setNotification = ({ message, resource }) => ({
  type: `${resource} ${SET_NOTIFICATION}`,
  payload: message,
  meta: { resource }
});

export const removeNotification = ({ notificationId, resource }) => ({
  type: `${REMOVE_NOTIFICATION}`,
  payload: notificationId,
  meta: { resource }
});



// WEBPACK FOOTER //
// ./src/redux/actions/notificationActions.js